var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666626 8C0.666626 3.58172 4.24835 0 8.66663 0H16.6666C21.0849 0 24.6666 3.58172 24.6666 8V16C24.6666 20.4183 21.0849 24 16.6666 24H8.66663C4.24835 24 0.666626 20.4183 0.666626 16V8Z",
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 8.66667V4.30667C13.2754 4.53733 13.8354 4.89267 14.31 5.36667L16.6327 7.69067C17.1074 8.16467 17.4627 8.72467 17.6934 9.33333H13.3334C12.9654 9.33333 12.6667 9.034 12.6667 8.66667ZM13.5134 16.9867C12.9714 17.5287 12.6667 18.2633 12.6667 19.03V20H13.6367C14.4034 20 15.138 19.6953 15.68 19.1533L20.218 14.6153C20.816 14.0173 20.816 13.0467 20.218 12.4487C19.62 11.8507 18.6494 11.8507 18.0514 12.4487L13.5134 16.9867ZM11.3334 19.03C11.3334 17.902 11.7727 16.8413 12.57 16.044L17.108 11.506C17.3674 11.2467 17.6694 11.0473 17.9954 10.9053C17.9927 10.8253 17.9894 10.746 17.984 10.666H13.3334C12.2307 10.666 11.3334 9.76867 11.3334 8.666V4.016C11.226 4.00867 11.1187 4 11.01 4H8.00002C6.16202 4 4.66669 5.49533 4.66669 7.33333V16.6667C4.66669 18.5047 6.16202 20 8.00002 20H11.3334V19.03Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0c940c20ecb52ec6a035c1c712fb4af2.svg";
export { ForwardRef as ReactComponent };